<template>
  <div id="page-connection-edit">

    <vs-alert color="danger" title="Connection Not Found" :active.sync="notFound">
      <span>Connection record with id: {{ $route.params.connectionId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-connection-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>
    <vx-card v-if="connection">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Conexão" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <connection-edit-tab-account class="mt-4" :data="connection" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import ConnectionEditTabAccount from './ConnectionEditTabAccount.vue'

// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    ConnectionEditTabAccount
  },
  data () {
    return {
      connection: null,
      notFound: false,
      activeTab: 0
    }
  },
  watch: {
    activeTab () {
      this.getConnection(this.$route.params.connectionId)
    }
  },
  methods: {
    async getConnection (connectionId) {
      try {
        this.$vs.loading()
        const { data } = await this.$http.get(
          `/api/v1/admin/company/connections/${connectionId}`,
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        const response = await this.$http.get(
          '/api/v1/admin/company/checklists',
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        const responseAllConnections = await this.$http.get(
          '/api/v1/admin/company/connections',
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        this.connection = data
        this.connection.checklists = response.data.map(e => { return { id: e.id, label: e.name } })
        this.connection.checklistConnection = this.connection.checklists.find(e => e.id === this.connection.checklistConnection)
        this.connection.logisticOperators = responseAllConnections.data.filter(e => e.type === 'Operador logístico').map(e => { return { id: e.id, label: e.name } })
        this.connection.logisticOperatorConnection = this.connection.logisticOperators.find(e => e.id === this.connection.logisticOperatorConnectionId)
        this.connection.checks = []
      } catch (error) {
        this.notFound = true
      } finally {
        this.$vs.loading.close()
      }
    }
  },
  created () {
    // Register Module UserManagement Module
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.getConnection(this.$route.params.connectionId)
  }
}

</script>
